<!--DatePickerSelecao.svelte-->

<script>
    import { onMount } from "svelte";
    import { Card } from "@svelteuidev/core";
    import DropSelecaoData from "./DropSelecaoData.svelte"; // Importa o componente
    import Constantes from "../Classes/Constantes";
    import { DadosLogin } from "../Classes/Stores";

    export let saida;
    let id_assessoria = $DadosLogin.id_assessoria;
    let selectedDates = [];
    let showCalendar = false;
    let showModal = false;
    let showDropSelecaoData = false; // Controla a exibição do DropSelecaoData
    let selectedDate = null; // Armazena a data selecionada
    let currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();
    let classeSelecao = {};
    let selectedRows = [];
    export let selecaoTreinos = {}; // Objeto para armazenar as seleções { data: valor }
    let selectedDatesWithTreinos = []; // Lista de datas que têm seleções
    let saidas = {};
    const daysOfWeek = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
    let config_selecao_treino = {
        api: Constantes.api_consultar_padrao,
        query_code: "consulta_treinos_corrida_paginado",
        campos_pesquisaveis: ["Treino"],
        colunas_exibidas: ["Treino"],
        coluna_saida: "id",
        parametro_adicional: $DadosLogin.id_assessoria,
        titulo: "Selecione os treinos", 
    };
    console.log("para ad ,",$DadosLogin.id_assessoria)
    function toggleDate(date) {
        openDropSelecaoData(date); // Abre o DropSelecaoData ao selecionar uma data
    }

    function formatDate(date) {
        if (date instanceof Date) {
            return date.toISOString().split("T")[0];
        }
        return date;
    }

    function handleDateSelection() {
        //saida = selectedDates;
        saida = saidas;
        closeModal();
    }

    function clearSelection() {
        selectedDates = [];
        saida = "";
        saidas = {};
        selectedRows = [];
        selectedDate = "";
        classeSelecao = {};
        selectedDatesWithTreinos = [];
        selecaoTreinos = {};
    }

    function isDateSelected(date) {
        const formattedDate = formatDate(date);
        console.log("classe", classeSelecao);
        if (selectedDates.includes(formattedDate)) {
            // Verifica se a data está na lista de datas com seleções
            if (selectedDatesWithTreinos.includes(formattedDate)) {
                classeSelecao[formattedDate] = "day  green";
            } else {
                classeSelecao[formattedDate] = "day ";
            }
        } else {
            // classeSelecao[formattedDate] = "day";
        }
    }

    function getDaysInMonth(year, month) {
        const dates = [];
        const date = new Date(year, month, 1);
        const firstDay = date.getDay();

        // Adiciona dias em branco na primeira semana
        for (let i = 0; i < firstDay; i++) {
            dates.push(null);
        }

        while (date.getMonth() === month) {
            dates.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }

        return dates;
    }

    function changeMonth(direction) {
        if (direction === "prev") {
            currentMonth--;
            if (currentMonth < 0) {
                currentMonth = 11;
                currentYear--;
            }
        } else if (direction === "next") {
            currentMonth++;
            if (currentMonth > 11) {
                currentMonth = 0;
                currentYear++;
            }
        }
        dates = getDaysInMonth(currentYear, currentMonth);
    }

    function removeDate(date) {
        const formattedDate = formatDate(date);
        
        selectedDates = selectedDates.filter((d) => d !== formattedDate);
        // Remove a data da lista de datas com seleções
        selectedDatesWithTreinos = selectedDatesWithTreinos.filter(
            (date) => date !== formattedDate,
        );

        delete selecaoTreinos[formattedDate]; // Remove a data do JSON
        classeSelecao[formattedDate] = "day";
        ApagarElemento(date);
        saida=saidas;
        isDateSelected(date);
    }

    function openDropSelecaoData(date) {
        selectedDate = date; // Armazena a data selecionada
        showDropSelecaoData = true; // Exibe o DropSelecaoData
    }

    function closeDropSelecaoData() {
        showDropSelecaoData = false; // Fecha o DropSelecaoData
    }

    let dates = [];
    function closeModal() {
        showModal = false;
    }

    onMount(() => {
        dates = getDaysInMonth(currentYear, currentMonth);
    });

    function formatDateToBrazilian(dateStr) {
        if (typeof dateStr !== "string") {
            throw new TypeError("O argumento fornecido não é uma string");
        }

        const date = new Date(dateStr);

        if (isNaN(date)) {
            throw new TypeError("A string fornecida não é uma data válida");
        }

        const daysOfWeek = [
            "Domingo",
            "Segunda-feira",
            "Terça-feira",
            "Quarta-feira",
            "Quinta-feira",
            "Sexta-feira",
            "Sábado",
        ];
        const day = (date.getDate() + 1).toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        let dayOfWeek = daysOfWeek[date.getDay()+1];
        if(dayOfWeek == undefined || dayOfWeek == null || dayOfWeek<0       ){
            dayOfWeek = daysOfWeek[0];
        }
        return `${day}/${month}/${year} - ${dayOfWeek}`;
    }

    function formatDateToISO(date) {
        // Verifica se o argumento é uma instância de Date
        if (!(date instanceof Date)) {
            throw new TypeError(
                "O argumento fornecido não é uma instância de Date",
            );
        }

        // Converte a data para o formato ISO e remove o horário
        const isoString = date.toISOString();
        return isoString.split("T")[0];
    }

    function Selecionado(e) {
        const { data, dado } = e.detail;
        const formattedDate = formatDateToISO(new Date(data));
       

        if (e.detail.selectedRows && e.detail.selectedRows.length > 0) {
            if (!selectedDates.includes(formattedDate)) {
                selectedDates = [...selectedDates, formattedDate];
            }

            // Quando selectedRows não está vazio
            selectedRows[data] = e.detail.selectedRows;
            saidas[formattedDate] = e.detail.selectedRows;
            console.log("e.detail.selectedRows", e.detail.selectedRows);

            // Adiciona ou atualiza a seleção no JSON
            selecaoTreinos[formattedDate] = dado;

            // Adiciona a data na lista de datas com seleções se ainda não estiver lá
            if (!selectedDatesWithTreinos.includes(formattedDate)) {
                selectedDatesWithTreinos = [
                    ...selectedDatesWithTreinos,
                    formattedDate,
                ];
            }

            // Marca a data no calendário como selecionada (verde)
            classeSelecao[formattedDate] = "day green";
        } else {
            // Quando selectedRows está vazio ou não existe
            ApagarElemento(data);
        }
        console.log("selec ", selectedDates);
        saida = saidas;
        console.log("Seleções atuais:", saidas); // Para ver as seleções no console
    }

    function ApagarElemento(data) {
         const formattedDate = formatDateToISO(new Date(data));
        delete selecaoTreinos[formattedDate]; // Remove a data do JSON

        selectedDates = selectedDates.filter((item) => item !== formattedDate);
       
        selectedRows[data] = []; // Atualiza a seleção
        delete saidas[formattedDate];
        //console.log("e.detail.selectedRows", e.detail.selectedRows);

        // Remove a data da lista de datas com seleções
        selectedDatesWithTreinos = selectedDatesWithTreinos.filter(
            (date) => date !== formattedDate,
        );

        // Remove a marcação de seleção do calendário
        classeSelecao[formattedDate] = "day";
    }
</script>

<div class="container">
    <Card shadow="sm" padding="sm">
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <label for="date-input" class="form-label"
                        >Selecione as datas:</label
                    >
                    <input
                        id="date-input"
                        type="text"
                        class="form-control"
                        readonly
                        placeholder="Selecione as datas"
                        on:click={() => (showModal = true)}
                    />
                </div>
            </div>
        </div>
        <div
            class="selected-dates-container"
            style="max-height: 300px; overflow-y: auto;"
        >
            {#each selectedDates as date}
                <div class="input-group mb-3">
                    <input
                        type="text"
                        class="form-control"
                        readonly
                        value={formatDateToBrazilian(date)}
                    />
                    <button
                        class="btn btn-outline-secondary"
                        type="button"
                        on:click={() => removeDate(date)}
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            {/each}
        </div>
    </Card>
</div>

{#if showModal}
    <div
        class="modal d-block"
        tabindex="-1"
        aria-labelledby="calendarModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="calendarModalLabel">
                        Selecione as datas
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                        on:click={() => (showModal = false)}
                    ></button>
                </div>
                <div class="modal-body">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between">
                                <span
                                    class="arrow"
                                    on:click={() => changeMonth("prev")}>❮</span
                                >
                                <span
                                    >{new Date(
                                        currentYear,
                                        currentMonth,
                                    ).toLocaleDateString("default", {
                                        month: "long",
                                        year: "numeric",
                                    })}</span
                                >
                                <span
                                    class="arrow"
                                    on:click={() => changeMonth("next")}>❯</span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="days-of-week">
                                {#each daysOfWeek as day}
                                    <div>{day}</div>
                                {/each}
                            </div>
                            <div class="calendar">
                                {#each dates as date}
                                    <div
                                        class="day {classeSelecao[
                                            formatDate(date)
                                        ]}"
                                        on:click={() => {
                                            date && toggleDate(date);
                                            isDateSelected(date);
                                        }}
                                    >
                                        {date ? date.getDate() : ""}
                                    </div>
                                {/each}
                            </div>
                            <button
                                class="btn btn-secondary me-2"
                                on:click={clearSelection}>Limpar</button
                            >
                            <button
                                class="btn btn-primary"
                                on:click={handleDateSelection}>Confirmar</button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}

{#if showDropSelecaoData}
    <DropSelecaoData
        config={config_selecao_treino}
        selectedRows={selectedRows[selectedDate]}
        data={selectedDate}
        bind:showModal={showDropSelecaoData}
        on:selecionado={Selecionado}
        on:close={closeDropSelecaoData}
    />
{/if}

<style>
    /* ... outros estilos ... */

    .selected {
        background-color: grey;
        color: white;
    }

    .green {
        background-color: green;
        color: white;
    }

    .modal.d-block {
        display: block;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999;
    }

    .calendar {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
    }

    .day {
        padding: 10px;
        text-align: center;
        cursor: pointer;
    }

    .selected {
        background-color: grey;
        color: white;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .days-of-week {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
        text-align: center;
    }

    .arrow {
        cursor: pointer;
    }

    .selected-dates-container {
        margin-top: 10px;
    }

    .btn-outline-secondary {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fa-trash {
        pointer-events: none;
    }
</style>
